import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { global } from '../global';
export interface MenuItem {
  r: string;
  submenu: Submenu[];
  action: string;
  label: string;
}

export interface Submenu {
  submenu2: Submenu2[];
  action: string;
  label: string;
}

export interface Submenu2 {
  r?: string;
  action: string;
  label: string;
}
export interface Condicion {
  idindicador: number;
  indicador: string;
  detalle: string | null;
  resumen: string | null;
  idlista: number;
  editable: boolean;
}
export interface CondicionesResponse {
  condiciones: Condicion[];
}
export interface IndicatorResponse {
  indicador: string;
  contador: number;
  id: number;
  idsList: number[];
}
@Injectable({
  providedIn: 'root'
})
export class MenuService {

  constructor(private http: HttpClient) {}

  getMenuData(): Observable<MenuItem[]> {
    return this.http.get<MenuItem[]>(`${global.url}menu`);
  }

  getCondicionesPorIndicador(indicador: string): Observable<CondicionesResponse> {
    return this.http.post<CondicionesResponse>(`${global.url}condicionesporindicador`, {
      indicador: indicador
    });
  }

  getIndicadoresPorTecnico(tecnico: boolean): Observable<IndicatorResponse[]> {
    return this.http.get<IndicatorResponse[]>(`${global.url}listaindicadoresportecnico2?tecnico=${tecnico}`);
  }
}